import React, { useState, useContext } from 'react';
import { Container, Row, Col, Nav, Button, Offcanvas } from 'react-bootstrap';
import { NavLink, Outlet } from 'react-router-dom';
import { AuthContext } from '../../AuthContext';

const AdminLayout = () => {
    const { logout } = useContext(AuthContext);
    // State to control the visibility of the offcanvas sidebar on mobile
    const [showSidebar, setShowSidebar] = useState(false);

    const handleSidebarClose = () => setShowSidebar(false);
    const handleSidebarShow = () => setShowSidebar(true);

    const linkStyle = {
        color: '#333',
        textDecoration: 'none',
        display: 'block',
        padding: '0.75rem 1rem',
        borderRadius: '0.25rem',
        transition: 'background-color 0.2s ease-in-out',
    };
    const activeLinkStyle = {
        ...linkStyle,
        backgroundColor: '#e9ecef',
        color: '#000',
        fontWeight: 'bold',
    };

    // This is the content for our sidebar, we define it once
    const sidebarContent = (
        <>
            <Nav className="flex-column">
                {/* When a link is clicked, close the sidebar on mobile */}
                <Nav.Item>
                    <NavLink to="/admin/dashboard" style={({ isActive }) => isActive ? activeLinkStyle : linkStyle} onClick={handleSidebarClose} end>
                        <i className="fas fa-tachometer-alt me-2"></i> Dashboard
                    </NavLink>
                </Nav.Item>
                <Nav.Item>
                    <NavLink to="/admin/users" style={({ isActive }) => isActive ? activeLinkStyle : linkStyle} onClick={handleSidebarClose}>
                        <i className="fas fa-users me-2"></i> Users
                    </NavLink>
                </Nav.Item>
                <Nav.Item>
                    <NavLink to="/admin/listings" style={({ isActive }) => isActive ? activeLinkStyle : linkStyle} onClick={handleSidebarClose}>
                        <i className="fas fa-list-alt me-2"></i> Listings
                    </NavLink>
                </Nav.Item>
                <Nav.Item>
                    <NavLink to="/admin/reports" style={({ isActive }) => isActive ? activeLinkStyle : linkStyle} onClick={handleSidebarClose}>
                        <i className="fas fa-exclamation-triangle me-2"></i> Reported
                    </NavLink>
                </Nav.Item>
                <Nav.Item>
                    <NavLink to="/admin/moderation-queue" style={({ isActive }) => isActive ? activeLinkStyle : linkStyle} onClick={handleSidebarClose}>
                        <i className="fas fa-gavel me-2"></i> Moderacija
                    </NavLink>
                </Nav.Item>
                <Nav.Item>
                    <NavLink to="/admin/categories" style={({ isActive }) => isActive ? activeLinkStyle : linkStyle} onClick={handleSidebarClose}>
                        <i className="fas fa-tags me-2"></i> Categories
                    </NavLink>
                </Nav.Item>
                <Nav.Item>
                    <NavLink to="/admin/blog" style={({ isActive }) => isActive ? activeLinkStyle : linkStyle} onClick={handleSidebarClose}>
                        <i className="fas fa-blog me-2"></i> Blog
                    </NavLink>
                </Nav.Item>
            </Nav>
            <hr />
            <Nav className="flex-column">
                <Nav.Item>
                    <Nav.Link onClick={logout} className="text-danger" style={{ cursor: 'pointer' }}>
                        <i className="fas fa-sign-out-alt me-2"></i> Logout
                    </Nav.Link>
                </Nav.Item>
            </Nav>
        </>
    );

    return (
        <Container fluid className="my-4">
            {/* This button is only visible on screens smaller than md (mobile/tablet) */}
            <Button variant="outline-secondary" className="d-md-none mb-3" onClick={handleSidebarShow}>
                <i className="fas fa-bars me-2"></i> Admin Menu
            </Button>

            <Row>
                {/* --- FIX IS HERE --- */}
                {/* On desktop, this Col is a normal sidebar. On mobile, it's hidden. */}
                <Col md={3} lg={2} className="d-none d-md-block bg-light sidebar border-end pt-3">
                    {sidebarContent}
                </Col>

                {/* The main content area */}
                <Col md={9} lg={10} className="ms-sm-auto px-md-4">
                    <Outlet />
                </Col>
            </Row>

            {/* This Offcanvas component contains the sidebar for mobile view */}
            <Offcanvas show={showSidebar} onHide={handleSidebarClose} responsive="md" className="d-md-none">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Admin Navigation</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {sidebarContent}
                </Offcanvas.Body>
            </Offcanvas>
        </Container>
    );
};

export default AdminLayout;